<template>
  <div slot="pop-body">
    <div class="my-pop-alert">
      <div class="my-pop-alert-top">
        <span>{{ popupTitle }}</span>
        <div class="my-pop-alert-top-button-container">
          <template v-if="currentTabType === 'notifications'">
            <button
              type="button"
              class="my-pop-alert-top-btn"
              @click.prevent="changeTab('watch-reservation')"
            >
              <alarm-outline-icon width="20" height="20" color="white" />
              <span>시청예약</span>
            </button>
            <button
              type="button"
              class="my-pop-alert-top-btn"
              @click.prevent="changeTab('setting')"
            >
              <Notification-icon width="20" height="20" color="white" />
              <span>알림설정</span>
            </button>
          </template>
          <template v-else>
            <button
              type="button"
              class="my-pop-alert-top-btn"
              @click.prevent="changeTab('notifications')"
            >
              <Notification-icon width="20" height="20" color="white" />
              <span>알림함</span>
            </button>
          </template>
        </div>
      </div>
      <alarms-setup v-if="currentTabType === 'setting'" />
      <alarm-list v-if="currentTabType === 'notifications'" />
      <alarm-list-live v-if="currentTabType === 'watch-reservation'" />
    </div>
  </div>
</template>
<script setup>
  import AlarmsSetup from '@/components/mypooq/AlarmsSetup'
  import AlarmList from '@/components/mypooq/AlarmList'
  import AlarmListLive from '@/components/mypooq/AlarmListLive'
  import { NotificationIcon, AlarmOutlineIcon } from '@/components/Icons'
  import { computed, ref } from 'vue'

  const ALARM_TAB_LIST = [
    { type: 'notifications', title: '알림함' },
    { type: 'watch-reservation', title: '시청예약' },
    { type: 'setting', title: '알림설정' },
  ]

  const currentTabType = ref('notifications')

  const popupTitle = computed(() => {
    return (
      ALARM_TAB_LIST.find((tab) => tab.type === currentTabType.value)?.title ||
      '알림함'
    )
  })

  const changeTab = (type) => {
    const isValidType = ALARM_TAB_LIST.some((tab) => tab.type === type)
    if (!isValidType) {
      currentTabType.value = 'notifications'
      return
    }
    currentTabType.value = type
  }
</script>
